// Mock API for demo without backend
const mockUsers = new Map();

// Pre-populate demo accounts
mockUsers.set('admin@demo.com', {
  id: 'demo-admin',
  email: 'admin@demo.com',
  password: 'admin123',
  firstName: 'Admin',
  lastName: 'Demo',
  role: 'manager',
  avatar: null,
});

mockUsers.set('member@demo.com', {
  id: 'demo-member',
  email: 'member@demo.com',
  password: 'member123',
  firstName: 'Member',
  lastName: 'Demo',
  role: 'member',
  avatar: null,
});

export const mockApi = {
  async login(email: string, password: string) {
    const user = mockUsers.get(email);
    if (!user || user.password !== password) {
      throw new Error('Invalid credentials');
    }
    
    const { password: _, ...userWithoutPassword } = user;
    return {
      user: userWithoutPassword,
      accessToken: 'mock-token-' + Date.now(),
      refreshToken: 'mock-refresh-' + Date.now(),
    };
  },

  async signup(data: any) {
    if (mockUsers.has(data.email)) {
      throw new Error('User already exists');
    }
    
    const newUser = {
      id: 'user-' + Date.now(),
      email: data.email,
      password: data.password,
      firstName: data.firstName,
      lastName: data.lastName,
      role: 'member',
      avatar: null,
    };
    
    mockUsers.set(data.email, newUser);
    
    const { password: _, ...userWithoutPassword } = newUser;
    return {
      user: userWithoutPassword,
      accessToken: 'mock-token-' + Date.now(),
      refreshToken: 'mock-refresh-' + Date.now(),
    };
  },
};